export function getConfig() {
  return {
    baseUrl: "/api",
    baseParams: {},
  };
}
